<template>
	<div>
		<q-dialog v-model="dialog" persistent transition-show="scale" transition-hide="scale">
			<div class="hris-modal">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">{{ name }} Access</h2>
				</div>
				<q-form ref="vForm" @submit="updateRole">
					<div class="hris-modal-body">
						<label class="hris-form-label">User List Actions</label>
						<q-option-group :options="options" label="Notifications" type="checkbox" v-model="accessGroup" color="green"></q-option-group>
					</div>
					<div class="hris-modal-footer">
						<q-btn unelevated class="hris-q-outline" label="Close" @click="closeModal"></q-btn>
						<q-btn unelevated class="hris-q-primary" label="Set Access" type="submit"></q-btn>
					</div>
				</q-form>
			</div>
		</q-dialog>
		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>
	</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			name:null,
			userID:null,
			spinner: false,
			dialog: false,
			ranks:[],
			accessGroup:[],
			options: []
		}
	},
	created(){
		this.eventHub.$on('UserAccess', this.openModal);
		
	},

	methods: {
		updateRole:function(){

			let formData = new FormData();
			formData.append("userID", this.userID);
			formData.append("access", this.accessGroup);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/role/access',formData)
			.then((res) => {
				this.$q.notify({
					message: 'Successful! Check it now!',
					color: 'green',
					position:'center',
					actions: [
				{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
				]
			})
				
			});
		},

		openModal:function(paylaod){
			this.dialog = paylaod.stat
			this.userID = paylaod.employee.row.id
			this.name = paylaod.employee.row.firstname +' ' + paylaod.employee.row.lastname
			this.displayModuleAccess()
		},

		closeModal:function(){
			this.dialog = false
		},

		displayModuleAccess: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/role/access/${this.userID}`)
			.then((res) => {
				var access= res.data.userAccess.moduleAction_id.split (",").map(Number)
				this.accessGroup = access
				//alert(this.accessGroup)
				this.options = res.data.modules		
				
			})

		},


	}
}
</script>
<style lang="css" scoped>
</style>